import { useCallback, useMemo, useState } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useClearedQueryParamValue } from 'src/app/shared/hooks/location';

import { MESSAGE_VALUES } from '../../constants';

type Result = ModelHookResult<{ message: string | undefined }, { closeBanner: () => void }>;

export function usePageBanner(): Result {
	const { typedTranslate } = useI18n();
	// if a query param is present, remove it from the url
	// so that the message doesn't show up when the user refreshes the page
	const confirmMessage = useClearedQueryParamValue('success');

	const messageValue = useMemo(() => (confirmMessage ? MESSAGE_VALUES[confirmMessage] : undefined), [confirmMessage]);

	const [message, setConfirmMessage] = useState(messageValue);
	const closeBanner = useCallback(() => setConfirmMessage(undefined), []);

	if (!confirmMessage || !messageValue || !message) {
		return { data: { message: undefined }, actions: { closeBanner } };
	}

	return {
		data: { message: typedTranslate(message) },
		actions: { closeBanner },
	};
}
